<button type="button" class="btn btn-{{type}}">
  <ng-content></ng-content>
</button>

